import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useLang } from '@/i18n';

export default function FirstKv() {
    const { t } = useLang('communitylang.firstKv');

    return (
        <div className={`firstKv ${css.firstKv}`}>
            <div className="kv-img-box">
                <NextImage src={require('@publicLocal/community/pc/kv.jpg')} />
            </div>
            <div className="kv-content-box">
                <p className="kv-title">{t('title')}</p>
                <p className="kv-desc">{t('desc')}</p>
            </div>
        </div>
    );
}
